export default {
    namespaced: true,
    state: () => ({
        token: null,
        authenticated: false,
        user: {},
    }),
    getters: {
        authenticated(state) {
            return state.authenticated
        },
        token(state) {
            return state.token
        },
        user(state) {
            return state.user
        }
    },
    mutations: {
        SET_AUTHENTICATED(state, value) {
            state.authenticated = value;
        },
        SET_USER(state, value) {
            state.user = value;
        },
        SET_TOKEN(state, value) {
            state.token = value;
        },
    },
    actions: {
        async storeToken({ commit }, token) {
            commit('SET_TOKEN', token)
            commit('SET_AUTHENTICATED', true)
        },
        async fetchData({ commit }) {
            const { useHttp } = await import('../composables/http');
            const $http = useHttp();
            await $http.get('/users').then(({ data }) => {
                commit('SET_USER', data.data)
                commit('SET_AUTHENTICATED', true)
            }).catch(() => {
                commit('SET_USER', {})
                commit('SET_AUTHENTICATED', false)
            })
            return true;
        },
        logout({ commit, dispatch }) {
            commit('SET_USER', {})
            commit('SET_AUTHENTICATED', false)
            commit('SET_TOKEN', '')
            dispatch('onboarding/reset', null, { root: true })
        }
    }
}
